module.exports = __webpack_public_path__ + "files/7a9bcf848024fdb02d50b000c489af8a.svg";